import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../BottomNav';
import theme from '../theme';

const regole = [
  {
    emoji: '✅',
    titolo: 'Più di 48 ore prima del lavoro',
    descrizione: 'Sia tu che l\'altra persona potete annullare liberamente, senza dover dare spiegazioni. Il pagamento viene rimborsato per intero e Jobbetty non trattiene nulla.',
    colore: 'primary',
  },
  {
    emoji: '⏰',
    titolo: 'Meno di 48 ore: il committente vuole annullare',
    descrizione: 'Se sei tu (il committente) a voler annullare a ridosso del lavoro, la richiesta viene inviata al lavoratore, che può scegliere come rispondere.',
    colore: 'warning',
  },
  {
    emoji: '❌',
    titolo: 'Il lavoratore rifiuta la cancellazione',
    descrizione: 'Se il lavoratore non è d\'accordo, riceve comunque il compenso pieno pattuito, come indennizzo per essersi organizzato per quel lavoro. La commissione Jobbetty resta trattenuta.',
    colore: 'error',
  },
  {
    emoji: '🤝',
    titolo: 'Il lavoratore accetta la cancellazione',
    descrizione: 'Se il lavoratore è d\'accordo, tu vieni rimborsato dell\'importo del lavoro. La commissione Jobbetty resta comunque trattenuta, mentre il lavoratore non riceve nulla.',
    colore: 'info',
  },
  {
    emoji: '🔄',
    titolo: 'Meno di 48 ore: il lavoratore vuole annullare',
    descrizione: 'Se è il lavoratore a dover annullare a ridosso del lavoro, tu (il committente) vieni rimborsato per intero, commissione inclusa. Jobbetty non trattiene nulla in questo caso.',
    colore: 'primary',
  },
];

const coloreMap = {
  primary: { bg: 'primaryLight', text: 'primary' },
  warning: { bg: 'warningBgSoft', text: 'warningText' },
  error: { bg: 'errorBg', text: 'errorDark' },
  info: { bg: 'infoBg', text: 'info' },
};

function PoliticaCancellazione() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family }}>
      <div style={{ background: theme.colors.primary, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: theme.colors.white, fontSize: 22, cursor: 'pointer', padding: 0 }}>←</button>
        <h2 style={{ margin: 0, color: theme.colors.white, fontSize: theme.font.size.xxl }}>🚫 Politica di cancellazione</h2>
      </div>

      <div style={{ padding: theme.spacing.xl, paddingBottom: 80 }}>

        <p style={{ fontSize: theme.font.size.md, color: theme.colors.textSecondary, lineHeight: 1.6, marginBottom: theme.spacing.xl }}>
          Quando una prenotazione viene accettata, il pagamento viene bloccato subito ma trasferito al lavoratore solo a lavoro concluso. Se devi annullare, le regole cambiano a seconda di <strong>quanto manca all'inizio del lavoro</strong> e di <strong>chi decide di annullare</strong>.
        </p>

        {regole.map((r, i) => {
          const c = coloreMap[r.colore];
          return (
            <div key={i} style={{
              border: `1px solid ${theme.colors.border}`, borderRadius: theme.radius.lg,
              padding: theme.spacing.lg, marginBottom: theme.spacing.md,
              display: 'flex', gap: theme.spacing.md, alignItems: 'flex-start',
            }}>
              <div style={{
                width: 40, height: 40, borderRadius: theme.radius.circle, flexShrink: 0,
                background: theme.colors[c.bg], display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 20,
              }}>
                {r.emoji}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: theme.font.size.md, color: theme.colors[c.text], marginBottom: 4 }}>
                  {r.titolo}
                </div>
                <div style={{ fontSize: theme.font.size.base, color: theme.colors.textSecondary, lineHeight: 1.6 }}>
                  {r.descrizione}
                </div>
              </div>
            </div>
          );
        })}

        <div style={{
          background: theme.colors.background, borderRadius: theme.radius.lg,
          padding: theme.spacing.lg, marginTop: theme.spacing.lg,
          fontSize: theme.font.size.sm, color: theme.colors.textMuted, lineHeight: 1.6,
        }}>
          💡 Per ora, le 48 ore si calcolano rispetto alla mezzanotte del giorno concordato per l'inizio del lavoro. Puoi avviare una cancellazione direttamente dalla chat della prenotazione, dove vedrai in tempo reale lo stato della richiesta.
        </div>

      </div>

      <BottomNav />
    </div>
  );
}

export default PoliticaCancellazione;